import {Component, OnInit} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';
import {NavigationEnd, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { MobilePackService } from '../../services/mobile-pack.service';
import { TerminalDeliveryService } from '../../services/terminal-delivery.service';
import { ShoppingCartService } from '../../services/shopping-cart-service';
import { DraftService } from '../../services/draft.service';
import { GeneralService } from '../../services/general.service';
import { TerminalDeliveryModel } from '../../interface/terminal-delivery-model';
import { ApiAmenaService } from '../../services/api-amena.service';

@Component({
    selector: 'app-shoping-cart',
    templateUrl: './shoping-cart.component.html',
    styleUrls: ['./shoping-cart.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class ShopingCartComponent implements OnInit {
    public enviroment = environment;
    public router: string;
    public itemTittle: string;
    public firstItem: number;
    public idOrderDraft: any;
    public terminalDelivery: TerminalDeliveryModel;
    public infoFijo: any;
    public dataCustomer: any;
    public cartAgreements: any = {
        cp_price: 0,
        terminals: [],
        vap_price: 0,
        show: false
    };

    constructor(
        public matDialog: MatDialog,
        private mobilePackService: MobilePackService,
        private terminalDeliveryService: TerminalDeliveryService,
        private shoppingCartService: ShoppingCartService,
        private draftService: DraftService,
        private _router: Router,
        private stepper: MatStepper,
        private generalService: GeneralService,
        private amenaApi: ApiAmenaService
    ) {
        this.draftService.getOrderIdDraft()
            .subscribe(data => {
                this.idOrderDraft = data;
            });
    }

    ngOnInit(): void {
        this.subscribeToServices();
        this.router = this._router.url;
        this.getTitle();

        this._router.events
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.router = this._router.url;
                    this.getTitle();
                }
            });

        this.terminalDeliveryService.getTerminalDelivery()
            .subscribe((data: TerminalDeliveryModel) => {
                this.terminalDelivery = data;
                this.getShoppingCart().setTerminalDelivery(data);
                this.shoppingCartService.setInitialTotal(this.shoppingCartService.getShoppingCart().getInitialTotal());
            });

        this.amenaApi.getDataFromCustomer()
            .subscribe((data: any) => {
                if (data) {
                    this.dataCustomer = data;
                }
            });
    }

    getTitle() {
        if (this.router === '/amena/solo_movil') {
            this.itemTittle = 'Móvil principal';
            this.firstItem = 0;
        } else {
            this.itemTittle = 'Fijo y móvil';
            this.firstItem = 1;
        }
    }

    subscribeToServices() {
        this.shoppingCartService.showCartSubscription.subscribe(show => this.changeVisibity(show));
        this.shoppingCartService.updateSubscrition.subscribe(data => this.updateCart(data));
    }

    changeVisibity(show) {
        if (show) {
            this.openCart();
        } else {
            this.closeCart();
        }
    }

    getShoppingCart() {
        return this.shoppingCartService.getShoppingCart();
    }

    updateCart(data) {
        this.shoppingCartService.getShoppingCart().update(data);
        this.shoppingCartService.setMonthlyTotal(this.shoppingCartService.getShoppingCart().getMonthlyTotal());
        this.shoppingCartService.setInitialTotal(this.shoppingCartService.getShoppingCart().getInitialTotal());
        this.shoppingCartService.setMonthlyDiscount(this.shoppingCartService.getShoppingCart().getMonthlyDiscount());
        if (this.getShoppingCart() && this.getShoppingCart().getOperation() && this.getShoppingCart().getOperation().getFormularioResultadoCobertura()) {
            this.infoFijo = this.getShoppingCart().getOperation().getFormularioResultadoCobertura();
        }
        this.productHasAgreement();
        if (this.idOrderDraft !== null) {
            this.shoppingCartService.getShoppingCart().getOperation().setOrderId(this.idOrderDraft);
        }
    }

    openCart() {
        if (document.getElementById('shopping-cart') !== null) {
            document.getElementById('shopping-cart').style.width = '350px';
        }
    }

    closeCart() {
        if (document.getElementById('shopping-cart') !== null) {
            document.getElementById('shopping-cart').style.width = '0px';
        }
    }

    goToStep(index) {
        this.shoppingCartService.getStepper().selectedIndex = index;
    }

    removeExtraLine(index) {
        this.matDialog
            .open(ConfirmDialogComponent, {
                data: {
                    title: 'Eliminar linea móvil adicional',
                    message: '¿Está seguro de querer eliminar la linea móvil adicional?'
                },
                panelClass: 'amena'
            })
            .afterClosed()
            .subscribe((confirm: boolean) => {
                if (confirm) {
                    this.draftService.removeMobile(index);
                    this.mobilePackService.setIndexToRemove(index);
                    this.shoppingCartService.getShoppingCart().removeItemsByStep(index);
                    this.shoppingCartService.setMonthlyTotal(this.shoppingCartService.getShoppingCart().getMonthlyTotal());
                    this.shoppingCartService.setInitialTotal(this.shoppingCartService.getShoppingCart().getInitialTotal());
                }
            });
    }

    logOperation() {
        console.log(this.shoppingCartService.getShoppingCart().getOperation().getAll());
        console.log('items : ', this.shoppingCartService.getShoppingCart().getItems());
        console.log(this.getShoppingCart());
    }

    getTerminalDeliveryTitle(): string {
        if (this.terminalDelivery.type === 1) {
            return 'Entrega en Correos';
        } else if (this.terminalDelivery.type === 2) {
            return 'Mensajería';
        } else if (this.terminalDelivery.type === 3) {
            return 'Coste del envío';
        }

        return '';
    }

    productHasAgreement() {
        const itemsCart = this.shoppingCartService.getShoppingCart().getItems();
        this.cartAgreements = {
            cp_price: 0,
            terminals: [],
            vap_price: 0,
            show: false
        };
        if (this.dataCustomer && this.dataCustomer.products && itemsCart && itemsCart.length) {
            var found = this.dataCustomer.products
                .filter(product => itemsCart
                .some(item => (item.portability === product.msisdn || item.portability_fijo === product.msisdn)))
            if (found && found.length) {
                found.map(product => {
                    if (product.type !== 'broadband' && product.agreements && product.agreements.length) {
                        product.agreements.map(agreement => {
                            if (agreement.type === 'CP' && agreement.price > 0) {
                                this.cartAgreements.cp_price += agreement.price;
                                this.cartAgreements.show = true;
                            }
                        })
                    }

                    if (product.terminal && product.terminal !== '' && product.terminal.agreement && product.terminal.agreement.type === 'VAP') {
                        this.cartAgreements.terminals.push(product.terminal);
                        this.cartAgreements.vap_price += product.terminal.pending_payment;
                        this.cartAgreements.show = true;
                    }
                })
            }
        }
    }
}
